import React from 'react'
import Fade from 'react-reveal/Fade'
import { CoverImg } from '../index'
import { hero } from '../../assets/imgs'
import './index.css'

const Hero = () =>
  <div className="hero">
    <Fade>
      <CoverImg src={hero} alt="hero" className="hero__img" position="50% 30%" />
    </Fade>
    <Fade>
      <div className="hero__text serif f5 fw4 dark tc m0-auto pa3 f2-ns pa4-ns">
        <p>The Law Office of Phillip Hamilton, PLLC is a New York City litigation boutique providing high-end, personalized service, and sound, strategic representation in all areas of law, with a particularized focus upon Criminal Defense and Civil Rights Actions.</p>
        <div className="hero__divider bg-red m0-auto mt4 mt5-ns" />
      </div>
    </Fade>
  </div>

export default Hero



// WEBPACK FOOTER //
// ./src/components/hero/index.js